import { useEffect } from 'react';
import { useUser } from 'hooks/useUser';
import { useButlletins } from 'hooks/corporatiu/useButlletins';
import Icona from 'components/corporatiu/Icona';
import Titol from 'components/corporatiu/Titol';
import Text from 'components/corporatiu/Text';
import Etiqueta from 'components/corporatiu/Etiqueta';
import Imatge from 'components/corporatiu/Imatge';
import BotoSubscripcio from 'components/corporatiu/Butlletins/BotoSubscripcio/';
import __isEmpty from 'lodash/isEmpty';
import styles from './portadabutlletins.module.scss';

const Periodicitat = (props) => {
    const periodicitat = props.periodicitat?.find((p) => p.main)?.desc;

    if (__isEmpty(periodicitat)) return <></>;
    return (
        <div className={styles.periodicitat}>
            <Icona className={styles.iconaCalendari} icona='calendari' isBlanc={false} inline={true} />
            <span className={styles.freq}>{periodicitat}</span>
        </div>
    );
};

const PortadaButlletins = (props) => {
    const { item } = props;
    const { id, titol, entradeta, observacions, imatges, periodicitat, etiqueta } = item;
    const { isAuthenticated, accessToken } = useUser();
    const { getSubscripcionsButlletins } = useButlletins();

    useEffect(() => {
        if (isAuthenticated && accessToken) {
            getSubscripcionsButlletins();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated, accessToken]);

    return (
        <div className={styles.content}>
            <div className={styles.col}>
                <div className={styles.infoWrapper}>
                    <div className={styles.avantitol}>
                        <Icona className={styles.iconaSobre} icona='sobre' isBlanc={false} mida={40} />
                        <span className={styles.textAvantitol}>Butlletí</span>
                    </div>
                    {etiqueta && (
                        <div className={styles.etiqueta}>
                            <Etiqueta titol={etiqueta} isBlanc={true} tema='butlleti' />
                        </div>
                    )}                    
                        
                    <div className={styles.contentInfo}>
                        <Titol titol={titol} className={styles.titol} tag='h1' tipus='seccio' />
                        <div className={styles.contentText}>
                            <Text className={styles.textEntradeta} text={entradeta} />
                            <Text className={styles.textEntradeta} text={observacions} />
                            <Periodicitat periodicitat={periodicitat} />
                        </div>
                    </div>
                    <div className={styles.contentBoto}>
                        <BotoSubscripcio id={id} titol={titol} />
                    </div>
                </div>
            </div>
            <div className={styles.col}>
                <div className={styles.imatgeWrapper}>
                    <Imatge
                        className={styles.imatge}
                        imatges={imatges}
                        tipus='web_poster_vertical'
                        layout='fill'
                        objectFit='cover'
                        alt={titol}
                        priority={true}
                        aria-hidden='true'
                    />
                </div>
            </div>
        </div>
    );
};

export default PortadaButlletins;
